import { Component, OnInit, EventEmitter, Output, Input, TemplateRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { SetAccess } from 'src/app/state-management';

@Component({
    selector: 'app-access-error-view',
    templateUrl: './access-error.component.html',
    standalone: false
})

export class AccessErrorComponent implements OnInit {

  constructor(private store: Store<{}>
  ) {
    this.store.dispatch(new SetAccess(false));
  }

  ngOnInit() {
  }
}
